import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Back = styled.a`
  text-decoration: none;
  color: inherit;
  font-size: 20px;
  &:hover {
    cursor: pointer;
  }
`;

const BackButton = ({ breadCrumb, updateSessionCrumbs }) => {
  return (
    <Back href={breadCrumb} rel="external" onClick={updateSessionCrumbs}>
      &lt; Back
    </Back>
  );
};

BackButton.propTypes = {
  breadCrumb: PropTypes.string,
  updateSessionCrumbs: PropTypes.func
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/components/BackButton/index.js